export default __webpack_public_path__ + "static/media/success.532d25e0.png";